var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.item)?_c('page-loading'):_vm._e(),(_vm.item)?_c('page-title',{attrs:{"title":_vm.pageTitle}}):_vm._e(),(_vm.item)?_c('station-scales',{attrs:{"scale-set":_vm.item,"is-editable":true,"no-master-warnings":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }